import React from 'react'

export default function StarIcon() {
  return(
    <svg
      className="svg-defs"
      version="1.1"
      width="0"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path id="star-icon" d="M17.7,26c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-1.2-6.1-7.7-10.9-15.8-11.8c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2
	C9.6,12.9,16.1,8.1,17.3,2c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c1.2,6.1,7.7,10.9,15.8,11.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2
	C25.4,15.2,18.9,19.9,17.7,26z"/>
      </defs>
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/components/Speakers/StarIcon/index.js